import { List, Skeleton } from '@fs/zion-ui'
import React from 'react'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'

export function NotesLoading(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <List>
        <Skeleton.ListItem hasSecondLine />
        <Skeleton.ListItem hasSecondLine />
        <Skeleton.ListItem hasSecondLine />
      </List>
    </SkeletonAnimationSyncDecorator>
  )
}
